<template>
<v-container fill-height fluid class="pa-0">
  <Modal v-if="listarParticipantes" :dialog="listarParticipantes">
    <div slot="header"></div>
    <div slot="body">
      <ListaParticipantes :evento="evento" :participantes="listaParticipantes"/>
    </div>
    <div slot="footer">
      <v-btn text color="primary" @click="listarParticipantes=false">Fechar</v-btn>
		</div>
	</Modal>

  <Modal v-if="listarDoacoes" :dialog="listarDoacoes">
    <div slot="header"></div>
    <div slot="body">
      <ListaDoacoes :doacoes="listaDoacoes" :evento="evento"/>
    </div>
    <div slot="footer">
     <v-btn text color="primary" @click="listarDoacoes=false">Fechar</v-btn>
		</div>
	</Modal>
  
  <Modal v-if="showModalDoacoes" :dialog="showModalDoacoes">
			<h3 slot="header">{{registro.titulo}}</h3>
			<div v-if="!cadastrarDoacao" slot="body" :class="{mensagem: this.itens.length == 0}">
				<h3 v-if="itens.length == 0">{{semItens}}</h3>
				<div v-else class="itens-doacao p-3">
					<v-data-table dense fixed-header class="table-item" :items="itens" :headers="doacoes.headers" :items-per-page="5">
						<template v-slot:item.action="{ item }">
						<v-btn text color="primary" id="btn-doacao" :disabled="item.qtd_pendente == '0'" title="Doar Item" variant="success" @click="doarItem(item)">
								Doar Item
							</v-btn>
						</template>
					</v-data-table>
				</div>
			</div>
			<div v-else class="itens-doacao p-3" slot="body">
				<v-container>
					<v-row>
						<v-col cols="6" md="3">
							<v-text-field value="1" type="number" label="Quantidade" :max="itemDoacao.qtd_pendente" min="1" id="itemDoacao-doacao" v-model="itemDoacao.qtd_doacao"></v-text-field>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div slot="footer">
				<v-btn v-if="cadastrarDoacao" text color="primary" @click="confirmarDoacao()">Confirmar Doacao</v-btn>
				<v-btn v-if="cadastrarDoacao" text color="primary" @click="cancelarDoacao(registro.id)">Cancelar</v-btn>
				<v-btn v-else text color="primary" @click="showModalDoacoes = false">Fechar</v-btn>
			</div>
	</Modal>
    
		
				<Evento @eventoCadastrado="atualizarEventos()" @fecharEvento="modalEvento = false" :mostrar="modalEvento" :evento="this.evento" :locais="this.locais" :atividades="atividades" />
        <ItensDoacao :mostrar="cadastrarItensDoacao" :evento="this.registro"  />
    
    


  <v-row class="ma-0">
			<v-col cols="12">
        
      <v-sheet height="64">
        <v-toolbar dense elevation="1" color="white">
          <v-btn outlined class="mr-4 d-none d-sm-flex" color="grey darken-2" @click="setToday">Hoje</v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev"><v-icon small>mdi-chevron-left</v-icon></v-btn>
          <v-btn fab text small color="grey darken-2" @click="next"><v-icon small>mdi-chevron-right</v-icon></v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" outlined color="grey darken-2" v-on="on">
                <span>{{local.text}}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item  v-for="l in locais" :key="l.value" @click="mudaLocal(l)">
                <v-list-item-title>{{l.text}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn class="d-none d-sm-flex" outlined color="grey darken-2" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list >
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="cadastrarNovoEvento()" :disabled="!this.verificaAcesso(this.acessos.CADASTRARNOVOEVENTO)" class="mx-2" color="primary" small>Novo</v-btn>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :event-color="getEventColor" 
        :now="today"
          :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange">
          </v-calendar>
        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title class="mr-4 pr-4">{{selectedEvent.name}} {{ informarStatus(selectedEvent.ativo, selectedEvent.status)}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-divider vertical class="mx-1"></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <!-- <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent.ativo, selectedEvent.status, selectedEvent.id_iniciado)" icon @click="editarEvento(selectedEvent)"> -->
                  <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent, 'editar')" icon @click="editarEvento(selectedEvent)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-divider vertical class="mx-1"></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent, 'cancelar')" icon @click="cancelarAtividade(selectedEvent)">
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar Atividade</span>
              </v-tooltip>
              <v-dialog v-model="dialogCancelarAtividade" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <h2>Cancelamento de atividade</h2>
                        </v-card-title>
                        <v-card-text class="mt-4">
                            <p>Você está cancelando a atividade abaixo:</p>
                            <p>Código: {{this.evento.id}}<br/>Nome: {{this.evento.titulo}}</p>
                            
                            <h3>Deseja confirmar o cancelamento?<br />Essa operação não poderá ser desfeita!</h3>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="primary" @click="confirmarCancelamentoAtividade()">Confirmar</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dialogCancelarAtividade = false">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
              <v-divider vertical class="mx-1"></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent, 'doar')" icon @click="realizarDoacoes(selectedEvent)">
                    <v-icon>mdi-cart</v-icon>
                  </v-btn>
                </template>
                <span>Realizar Doação</span>
              </v-tooltip>
              <v-divider vertical class="mx-1"></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent, 'cadastrarDoacoes')" icon @click="CadastrarDoacoes(selectedEvent)">
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-btn>
                </template>
                <span>Cadastrar Doações</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon :disabled="inativarBotoes(selectedEvent, 'listarDoacoes')" @click="buscarDoacoes(selectedEvent)">
                    <v-icon>mdi-format-list-numbered</v-icon>
                  </v-btn>
                </template>
                <span>Listar Doações</span>
              </v-tooltip>
              <v-divider vertical class="mx-1"></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" :disabled="inativarBotoes(selectedEvent, 'listarParticipantes')" icon @click="buscarParticipantes(selectedEvent)">
                    <v-icon>mdi-account-group</v-icon>
                  </v-btn>
                </template>
                <span>Listar Participantes</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text>
              <p>Código: {{selectedEvent.id}}<br />
              Data: {{selectedEvent.data_evento}}<br />
              Horário: {{selectedEvent.inicio}}<br />
              Local: {{selectedEvent.descricao_local}}<br />
              Tipo: {{selectedEvent.tipo_descricao}}<br />
              Grau: {{selectedEvent.grau}}<br />
              Iniciado: {{selectedEvent.nome_iniciado}}<br />
              Observação: {{selectedEvent.observacao}}<br />
              Sua participação: {{selectedEvent.confirmacao}}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" @click="confirmarEvento(selectedEvent.id)" :disabled="inativarBotoes(selectedEvent, 'confirmar')">Participar</v-btn>
              <v-btn text color="primary" @click="recusarEvento(selectedEvent.id)" :disabled="inativarBotoes(selectedEvent, 'recusar')">Não Participar</v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="selectedOpen = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
  </v-container>
</template>
<script>

import axios from 'axios'
import {baseApiUrl, showError, showSuccess} from '@/config/global'
import { mapState } from 'vuex'
import Modal from '@/components/geral/Modal'

import ListaDoacoes from '@/components/calendario/ListaDoacoes'
import ListaParticipantes from '@/components/calendario/ListaParticipantes'
import ItensDoacao from '@/components/calendario/ItensDoacao'
import Evento from '@/components/calendario/Evento'
import Br from '@/config/barramento'
import ACESSOS from '@/Enums/Acessos.js'
import metodos from '@/mixins/metodos'

  export default {
    mixins: [metodos],
    components:{Modal, ListaDoacoes, ListaParticipantes, Evento, ItensDoacao},
    data: () => ({
      acessos: ACESSOS,
      dialogCancelarAtividade: false,
      atividades: {},
      showModalDoacoes: false,
      cadastrarItensDoacao: false,
      cadastrarDoacao: false,
      listarParticipantes: false,
      listarDoacoes: false,
      listaParticipantes: {},
      listaDoacoes: {},
      evento: {},
      itens: [],
      itemDoacao: {},
      semItens: "",
			registro: {},
      doacoes:{
					headers:[
						{text: 'Código', value: 'id_item', align: 'center', divider: true},
						{text: 'Nome', value: 'nome', align: 'center', divider: true},
						{text: 'Qtd', value: 'quantidade', align: 'center', divider: true},
						{text: 'Qtd pendente', value: 'qtd_pendente', align: 'center', divider: true},
						{text: 'Und', value: 'nome_unidade', align: 'center', divider: true},
						{text: 'Ações', value: 'action', align: 'center', divider: true}
					],
					itens:[

					]
				},
      modalEvento: false,
      locais: [],
      local: {
        value: '0',
        text: 'Todos'
      },
      eventos: {},
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        '4day': '4 Dias',
      },
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    }),
    computed: {
      ... mapState(['buscandoDados', 'user']),

      today(){
        let dt = new Date()
        
        return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds()
        
      },

      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }
        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear

        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
          case '4day':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    mounted () {
      this.$refs.calendar.checkChange()
    },
    created(){
      
      this.buscaDados()
      Br.onFecharDoacoes(() => {
        this.fecharDoacoes();
      })
      Br.onFecharEdicaoEvento(tx => {
        this.fecharEdicaoEvento();
        if(tx == 'atualizado'){
          this.updateRange(this)
        }
      })
    },

    watch:{
  
    },
    methods: {

      atualizarEventos(){
        this.updateRange(this)
      },

      doarItem(item){
				
				this.itemDoacao.id_item = item.id_item
				this.itemDoacao.qtd_pendente = item.qtd_pendente
				this.itemDoacao.qtd_doacao = 0
				
				this.cadastrarDoacao = true
      },
      
      confirmarDoacao(){
        if(this.itemDoacao.qtd_doacao == 0){
          showError("Quantidade deve ser maior que zero")
          return false
        }
				const url = `${baseApiUrl}/itensDoacoes/registrar.php`
				
				this.itemDoacao.id_iniciado = this.user.iniciado

				axios.post(url, this.itemDoacao)
				.then(res => {
					
					if(res.data.codigo == '01'){
						
						let idx = this.itens.findIndex((v) => {
							return v.id_item == this.itemDoacao.id_item
						})

						this.itens[idx].qtd_pendente = this.itemDoacao.qtd_pendente - this.itemDoacao.qtd_doacao
						
						showSuccess(res.data.mensagem)
						this.cadastrarDoacao = false
						
					}else{
						
						showError(res.data.mensagem)
					}
				})

      },
      
      cancelarDoacao(){
				if(this.itemDoacao.id){
					this.atualizaItemCancelado(this.itemDoacao.id)
				}else{
					this.cadastrarDoacao = false
				}
			},

      fecharDoacoes(){
        this.cadastrarItensDoacao = false
      },

      fecharEdicaoEvento(){
        this.modalEvento = false
      },
      
      CadastrarDoacoes(registro){
        this.registro = registro
        this.cadastrarItensDoacao = true
      },



      Salvar(){

        this.evento = this.$store.state.novoEvento

        if(this.evento.objFim <= this.evento.objInicio){
					showError("Horário inicio deve ser menor que horário fim")
					return false
				}

				this.locais.forEach((v) => {
							if(this.evento.local == v.value){
								this.evento.local_nome = v.text
              }
						})

				
				
					const url = `${baseApiUrl}/eventos/insert.php`
					this.evento.iniciado = this.$store.state.user.iniciado
								
					if(this.evento.titulo && this.evento.grau && this.evento.objData_evento && this.evento.objInicio && this.evento.objFim && this.evento.tipo && this.evento.local){

						
						
						axios.post(url, this.evento)
						.then(res => {
							
							if(res.data.codigo == '01'){
								showSuccess('Atividade salva com sucesso')

                if(this.evento.tipo != '80'){
                  //const urlEmail = `${baseApiUrl}/emails/novoEvento.php`
                  //axios.post(urlEmail, this.evento)
                }

                this.modalEvento = false
                this.events = []
                this.updateRange(this)

							}else{
								showError(res.data.mensagem)
								return false
							}
							
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
						return false
      }
    },
      
      cadastrarNovoEvento(){
        this.evento = {}
        this.$store.commit('setCorEvento', 'primary')
        this.modalEvento = true
      },

      informarStatus(ativo, status){
        if(status == '0'){
          return " - Cancelado"
        }else if(ativo == '0'){
          return " - Atividade ja ocorreu"
        }
        return ""
      },

      inativarBotoes(evento, btn){
        switch(btn){
          case 'editar':
            if(evento.ativo == '0' || evento.status == '0' || evento.id_iniciado != this.user.iniciado || evento.permite_registro == 0){
              return true
            }
            break
          case 'cancelar':
            if(evento.ativo == '0' || evento.status == '0' || evento.id_iniciado != this.user.iniciado || evento.permite_registro == 0){
              return true
            }
            break
          case 'doar':
              if(evento.ativo == '0' || evento.status == '0' || evento.reserva == '1'){
                return true
              }
            break
          case 'cadastrarDoacoes':
            if(evento.ativo == '0' || evento.status == '0' || evento.reserva == '1' || evento.id_iniciado != this.user.iniciado){
                return true
              }
            break
          case 'listarDoacoes':
            if(evento.reserva == '1'){
                return true
              }
            break
          case 'listarParticipantes':
            if(evento.reserva == '1'){
                return true
              }
            break
          case 'confirmar':
            if(evento.ativo == '0' || evento.status == '0' || evento.reserva == '1'){
                return true
              }
            break
          case 'recusar':
            if(evento.ativo == '0' || evento.status == '0' || evento.reserva == '1'){
                return true
              }
            break
          default:
            return false
        }
      },

      inativarBtnReserva(evento){
        if(evento.reserva == "1"){
          return true
        }else{
          return false
        }
      },

      realizarDoacoes(registro){
				this.registro = registro
				this.itens = []
				this.buscaItens()
				this.showModalDoacoes = true
				
      },

      buscarParticipantes(evento){
        let listar = ""
        if(this.user.iniciado == evento.id_iniciado){
          listar = "todos"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARTODOSPARTICIPANTES)){
          listar = "todos"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARPARTICIPANTESPORCASA) && this.user.dados.sexo == "M"){
          listar = "masculino"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARPARTICIPANTESPORCASA) && this.user.dados.sexo == "F"){
          listar = "feminino"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARPARTICIPANTESCLA)){
          listar = "cla"
        }else{
          return
        }
        const url = `${baseApiUrl}/eventos/buscaParticipantes.php?grau=${evento.grau}&id_evento=${evento.id}&listar=${listar}&iniciado=${this.user.iniciado}`
        axios.get(url).then(res => { 
          this.listaParticipantes = res.data.map(r => {
            return {
              ... r,
            }
          })
          this.evento = evento
          this.listarParticipantes = true
        })
      },

      buscarDoacoes(evento){
        let listar = ""
        if(this.user.iniciado == evento.iniciado){
          listar = "todos"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARTODASDOACOES)){
          listar = "todos"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARDOACOESPORCASA) && this.user.dados.sexo == "M"){
          listar = "masculino"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARDOACOESPORCASA) && this.user.dados.sexo == "F"){
          listar = "feminino"
        }else if(this.verificaAcesso(this.acessos.VISUALIZARDOACOESCLA)){
          listar = "cla"
        }else{
          return
        }

        const url = `${baseApiUrl}/eventos/buscarDoacoes.php?id_evento=${evento.id}&listar=${listar}`
        axios.get(url).then(res => {
          this.listaDoacoes = res.data.map(r => {
            return {
              ... r,
            }
          })
        
        this.evento = evento
        this.listarDoacoes = true
        
        })
      },
      buscaItens(){

				const url = `${baseApiUrl}/itensEventos/read.php?id_evento=${this.registro.id}`
				this.semItens = ""
				axios.get(url)
				.then(res => {
					
					if(res.data.codigo == '01'){
					
						this.itens = res.data.dados.itens
						
					}else{
						//showError(res.data.mensagem)
						this.semItens = "Não há itens de doação para esse evento."
					}
				})
			},

      editarEvento(evento){
              this.$store.commit('setCorEvento', evento.color)
              this.evento = evento
              this.modalEvento = true
            },
      
      cancelarAtividade(evento){
        this.dialogCancelarAtividade = true
				this.evento = evento
      },

      confirmarCancelamentoAtividade(){
        
					const url = `${baseApiUrl}/eventos/cancelarEvento.php`
								
						axios.post(url, this.evento.id)
						.then(res => { 
							if(res.data.codigo == '01'){
								showSuccess('Atividade cancelada com sucesso')

                if(this.evento.tipo != '80'){
                  const urlEmail = `${baseApiUrl}/emails/cancelarEvento.php`

                  axios.post(urlEmail, this.evento)
                }
								
                
               this.events = []
               this.selectedOpen = false
               this.dialogCancelarAtividade = false
               this.updateRange(this)

							}else{
								showError(res.data.mensagem)
								return false
							}
							
						})
      },

      confirmarEvento(ev){
                const url = `${baseApiUrl}/eventos/confirmar.php`
                const params = {
                    id_evento: ev,
                    id_iniciado: this.user.iniciado,
                    statusConfirmacao: "1"
                }
                
                axios.post(url, params).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
						
						this.events.forEach((v, i) => {
							if(v.id == ev){
								this.events[i].confirmacao = "confirmado"
							}
						})

                    }else{
                        showError(res.data.mensagem)
                    }
                    
                })
            },

			 recusarEvento(ev){
                const url = `${baseApiUrl}/eventos/confirmar.php`
                const params = {
                    id_evento: ev,
                    id_iniciado: this.user.iniciado,
                    statusConfirmacao: "2"
                }
                
                axios.post(url, params).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.events.forEach((v, i) => {
							if(v.id == ev){
                
								this.events[i].confirmacao = "recusado"
							}
						})
                    }else{
                        showError(res.data.mensagem)
                    }
                    
                })
            },





      close(){
        this.modalEvento = false
        this.$store.commit('setCorEvento', 'primary')
      },
      mudaLocal(local){
        this.local = local
        
        this.updateRange(this);
      },
      dataFormatada(dt){
      var data = dt,
          dia  = data.getDate().toString(),
          diaF = (dia.length == 1) ? '0'+dia : dia,
          mes  = (data.getMonth()+1).toString(), //+1 pois no getMonth Janeiro começa com zero.
          mesF = (mes.length == 1) ? '0'+mes : mes,
          anoF = data.getFullYear();
        
        return anoF+"-"+mesF+"-"+diaF;
    },

      buscaDados(){
            const url = `${baseApiUrl}/eventos/cadastros.php`
            axios(url).then(res => {
                if(res.data.dados){
                    this.locais = res.data.dados.espacos.map(local =>{
                        
                          return {
                            value: local.id_espaco, text: local.descricao
                          }
                        
                    })
                       
                     this.atividades = res.data.dados.atividades.map(atv =>{
                         return{
                           ... atv
                         }
                     })
                    this.locais.unshift({value: "0", text: 'Todos'})
                }
            })
        },

      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = this.today
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },

       converterData(dt){
          let data = new Date(dt)
		      let difHorario = data.getTimezoneOffset() / 60
          data = new Date(data.setHours(data.getHours() + difHorario))
        
			return data
		},
      
      updateRange ( {start, end} ) {
        
        const events = []
        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        
        const url = `${baseApiUrl}/eventos/read.php?inicio=${this.dataFormatada(min)}&fim=${this.dataFormatada(max)}&grau=${this.$store.state.user.outros.grauAtual}&iniciado=${this.user.iniciado}&local=${this.local.value}`
        //const allDay = this.rnd(0, 3) === 0
        axios(url).then(res => {
          if(res.data){
            this.eventos = res.data.dados.map(ev => {
              return {
                ... ev,
                }
              }
            )
            this.eventos.forEach((v) => {
              v.objData_evento = this.converterData(v.objData_evento)
              v.objInicio = this.converterData(v.objInicio)
              v.objFim = this.converterData(v.objFim)

              events.push({
                name: v.titulo,
                reserva: v.reserva == '1' ? true : false,
                start: this.formatDate(v.objInicio),
                end: this.formatDate(v.objFim),
                color: v.ativo == '1' ? this.converterCor(v.cor) : this.converterCor(v.cor, .3),
                id: v.id,
                titulo: v.titulo,
                observacao: v.observacao,
                tipo: v.tipo,
                tipo_descricao: v.tipo_descricao,
                descricao_tipo: v.descricao_tipo,
                data_evento: v.data_evento,
                objData_evento: v.objData_evento,
                inicio: v.inicio,
                fim: v.fim,
                objInicio: v.objInicio,
                objFim: v.objFim,
                local: v.local,
                descricao_local: v.descricao_local,
                descricao_evento: v.descricao_evento,
                id_iniciado: v.id_iniciado,
                nome_iniciado: v.nome_iniciado,
                grau: v.grau == 'null' ? 0 : v.grau,
                confirmacao: v.confirmacao,
                ativo: v.ativo,
                status: v.status,
                permite_registro: v.permite_registro
              })
            })
            this.start = start
            this.end = end
            this.events = events
            
          }
        }
      )
    },
      nth(d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
      rnd(a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      formatDate(a, withTime) {
        return withTime
          ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
      },

      converterCor(hex, alpha = 1){
        const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
      }
    },
  }
</script>